// Device detection and links for subscribing to the personal calendar feed.
// detectDevice is pure (tested); currentDevice reads navigator / window.

// Apps whose in-app browser does not handle webcal:// or Google sign-in well
const IN_APP_TOKENS = /Telegram|FBAN|FBAV|Instagram|Line\/|GSA\/|MicroMessenger|WhatsApp/i;
// Other iOS browsers: webcal:// is unreliable outside Safari
const IOS_OTHER_BROWSERS = /CriOS|FxiOS|EdgiOS|OPiOS/;

export function detectDevice({ userAgent = '', platform = '', maxTouchPoints = 0, standalone = false } = {}) {
  const ipadDesktopUa = platform === 'MacIntel' && maxTouchPoints > 1;
  const ios = /iPhone|iPad|iPod/.test(userAgent) || ipadDesktopUa;
  const android = !ios && /Android/i.test(userAgent);

  let inApp = IN_APP_TOKENS.test(userAgent);
  if (ios) {
    // WKWebView in apps has no "Safari/" token
    inApp = inApp || IOS_OTHER_BROWSERS.test(userAgent) || !/Safari\//.test(userAgent);
  } else if (android) {
    inApp = inApp || /; wv\)/.test(userAgent);
  } else {
    inApp = false;
  }

  return { os: ios ? 'ios' : android ? 'android' : 'desktop', inApp, standalone: !!standalone };
}

export function currentDevice() {
  if (typeof navigator === 'undefined') return detectDevice();
  let standalone = navigator.standalone === true;
  try {
    standalone = standalone || window.matchMedia('(display-mode: standalone)').matches;
  } catch {
    // matchMedia unavailable — not standalone
  }
  return detectDevice({
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    maxTouchPoints: navigator.maxTouchPoints,
    standalone,
  });
}

// Google's "add by URL" page (subscription, not a one-off import)
export function googleSubscribeUrl(webcalUrl) {
  return `https://calendar.google.com/calendar/render?cid=${encodeURIComponent(webcalUrl)}`;
}

// ICSx⁵: free Android app that keeps an iCalendar subscription in the phone's calendar
export const ICSX5_STORE_URL = 'https://play.google.com/store/apps/details?id=at.bitfire.icsdroid';
